var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":{ name: 'association', params: { associationId: _vm.association.associationId } }}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.association.nom)}}),_c('v-list-item-subtitle',{domProps:{"textContent":_vm._s('SIREN: ' + _vm.association.siren)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }